import { API_URL } from '../../../app-config/constants';
import { FeedbackDetailsDto, ViewAs } from '../../react/features/YourFeedback/types';
import { get } from '../request';

const BASE_URL = `${API_URL}/unified-feedback`;

getById.operation = 'READ';
export function getById(id: string): Promise<FeedbackDetailsDto> {
    return get(`${BASE_URL}/details/${id}`);
}

export function getFeedbackDetailsViewedAs(feedbackId: string, view: ViewAs): Promise<FeedbackDetailsDto> {
    return get(`${BASE_URL}/details/${feedbackId}/view-as/${view}`);
}
